<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <div style="display: flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-data-table
      ref="theDataTable"
      :mobile-breakpoint="0"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :items-per-page="5"
      @pagination="pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <!-- chnage start -->

          <!-- Edit widget -->
          <v-dialog v-model="dialogConfigWidget" max-width="700px">
            <v-card>
              <v-card-title style="background-color: #0C479D;">
                <span class="text-h5 icon-white"
                  >Edit widget configuration</span
                >
              </v-card-title>
              <v-card-text style="width:100% ; padding: 15px;">
                <!-- <v-container class="ParameterConfigCard"> -->
                <!-- <v-row> -->
                <v-col style="display: flex; flex-wrap: wrap; ">
                  <v-col
                    cols="12"
                    xs="6"
                    sm="6"
                    md="4"
                    lg="4"
                    style="padding: 10px 10px !important;  "
                    v-for="(i, index) in allParametersKeyValue"
                    :key="index"
                  >
                    <!-- For rerendering the template , using count variable -->

                    <!-- <div style="z-index: -1 ;position: relative;">
                    {{ count }}
                  </div> -->
                    <div
                      @mouseover="showInfoMessage(index)"
                      @mouseout="hideInfoMessage(index)"
                    >
                      <div v-if="i['data_type'] === 'integer'">
                        <v-text-field
                          :messages="
                            i['showMessageBoolean'] ? i['info_message'] : ''
                          "
                          v-model="i['param_value']"
                          type="number"
                          :label="i['display_name']"
                          style="padding-top: 0 !important;"
                        >
                        </v-text-field>
                      </div>
                      <div v-if="i['data_type'] == 'string'">
                        <v-text-field
                          :messages="
                            i['showMessageBoolean'] ? i['info_message'] : ''
                          "
                          v-model="i['param_value']"
                          type="text"
                          :label="i['display_name']"
                          style="padding-top: 0 !important;"
                        >
                        </v-text-field>
                      </div>

                      <div v-if="i['data_type'] == 'boolean'">
                        <v-autocomplete
                          :messages="
                            i['showMessageBoolean'] ? i['info_message'] : ''
                          "
                          v-model="i['param_value']"
                          :items="boolean_val_param"
                          :label="i['display_name']"
                          style="padding-top: 0 !important;"
                        ></v-autocomplete>
                      </div>
                    </div>
                  </v-col>
                  <!-- </v-row> -->
                  <!-- </v-container> -->
                </v-col>
              </v-card-text>

              <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn rounded color="#FE000c" @click="closeConfigWidget">
                  <v-icon left class="icon-white">icon-cancel</v-icon>
                  <span style="color:white">Cancel</span>
                </v-btn>
                <v-btn rounded color="primary" @click="saveconfigWidget">
                  <v-icon left>icon-availability</v-icon>

                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- chnage end-->

          <v-dialog v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-width="50"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class=""
                    fab
                    small
                    color="#0C479D"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon class="icon-white">icon-download</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <!-- <v-list>
                  <v-list-item>
                   <v-list-item-avatar> 
              <img
                src="https://cdn.vuetifyjs.com/images/john.jpg"
                alt="John"
              >
            </v-list-item-avatar>

                  <v-list-item-content>
                  <v-list-item-title class="font-weight-bold text-blue text-uppercase">options</v-list-item-title>
                  <v-list-item-subtitle>Founder of Vuetify</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
              <v-btn
                :class="fav ? 'red--text' : ''"
                icon
                @click="fav = !fav"
              >
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-list-item-action>
                  </v-list-item>
                  </v-list> -->

                  <v-divider></v-divider>

                  <v-list>
                    <v-list-item>
                      <v-list-item-action>
                        <vue-json-to-csv
                          :json-data="dataDownload"
                          :csv-title="'Dash Board Configuration Data'"
                        >
                          <v-btn color="indigo" dark style="">
                            CSV
                          </v-btn>
                        </vue-json-to-csv>
                        <!-- <v-btn
          color="indigo"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Menu as Popover
        </v-btn> -->
                      </v-list-item-action>
                      <!-- <v-list-item-title>CSV Download</v-list-item-title> -->
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-action>
                        <v-btn @click="createPDF" color="indigo" dark
                          >PDF
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
              <v-btn
                class="mr-2 ml-4"
                small
                fab
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
                @click="addDoc()"
              >
                <v-icon class="icon-white">icon-add</v-icon>
              </v-btn>
            </template>

            <!-- Two different tabs are created while adding new dash borad with its paarameter -->

            <v-tabs color="primary">
              <v-tabs-slider></v-tabs-slider>
              <v-row>
                <v-col style="margin-top: 10px;height: 100%; padding: 0;">
                  <v-tab active style="height: 100%; background-color: #0C479D;"
                    ><span
                      class="icon-white pb-3"
                      style="font-family: Roboto !important; font-style: normal; font-weight: 700;"
                      >Add Dash Board Config</span
                    ></v-tab
                  >
                </v-col>
                <v-col
                  style="margin-top: 10px;height: 100%; padding: 0;"
                  v-if="EditParamView === true"
                >
                  <v-tab style="height: 100%;background-color: #0C479D;"
                    ><span
                      class=" pb-3 icon-white"
                      style="font-family: Roboto !important;  font-weight: 700;"
                      >Edit parameters</span
                    ></v-tab
                  >
                </v-col>
                <v-col
                  style="margin-top: 10px;height: 100%; padding: 0;"
                  v-else
                >
                  <v-tab
                    disabled
                    style="height: 100%;background-color: #0C479D;"
                  >
                    <span
                      class=" pb-3 icon-white"
                      style="font-family: Roboto !important;  font-weight: 700;"
                      >Edit parameters</span
                    ></v-tab
                  >
                </v-col>
              </v-row>

              <v-tab-item>
                <v-card style="max-height:60%">
                  <div>
                    <!-- <v-card-title> -->
                    <!-- <span class="text-h5">{{ formTitle }}</span> -->
                    <!-- </v-card-title> -->
                    <v-card-text style="padding:0">
                      <!-- <v-container> -->
                      <div style="display:flex; flex-wrap: wrap;">
                        <v-col
                          v-if="!isEdit"
                          cols="12"
                          sm="6"
                          md="6"
                          xs="12"
                          style="padding :0 10px"
                        >
                          <v-autocomplete
                            label="Machine*"
                            :items="machineItems"
                            v-model="editeditem.machine_name"
                            prepend-icon="icon-dpimm"
                            @change="setparametersData()"
                            item-text="machine_name"
                            item-value="machine_id"
                            required
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          xs="12"
                          style="padding :0 10px"
                        >
                          <v-autocomplete
                            label="Parameter*"
                            :items="parameters"
                            v-model="editeditem.parameter_id"
                            :disabled="
                              editeditem.machine_name !== '' ? false : true
                            "
                            item-text="parameter_name"
                            prepend-icon="icon-cog-single"
                            item-value="parameter_id"
                            required
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          xs="12"
                          style="padding :0 10px"
                        >
                          <v-text-field
                            label="Dashboard Name"
                            v-model="editeditem.alias_name"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="6"
                          xs="12"
                          v-if="!isEdit"
                          style="padding :0 10px"
                        >
                          <v-autocomplete
                            label="Group*"
                            :items="groupItems"
                            v-model="editeditem.group_id"
                            :disabled="
                              editeditem.machine_name !== '' &&
                              editeditem.parameter_id !== ''
                                ? false
                                : true
                            "
                            item-text="group_name"
                            item-value="group_id"
                            required
                            @change="
                              getparameterForNewdashBoradCreated(
                                editeditem.group_id
                              )
                            "
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="8" sm="8" md="6">
                          <label class="radiolabel">Enable</label>
                          <v-radio-group
                            v-model="editeditem.enable_status"
                            row
                            class="radiogroup"
                          >
                            <v-radio
                              label="Yes"
                              value="Y"
                              @change="changeActivestatus('Y')"
                            ></v-radio>
                            <v-radio
                              label="No"
                              value="N"
                              @change="changeActivestatus('N')"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </div>
                      <!-- </v-container> -->
                    </v-card-text>

                    <v-card-actions class="pb-5">
                      <v-spacer></v-spacer>
                      <v-btn rounded color="#FE000C" @click="close">
                        <v-icon left class="icon-white">icon-cancel</v-icon>
                        <span style="color: white;"> Cancel</span>
                      </v-btn>
                      <v-btn rounded color="primary" @click="save">
                        <v-icon left>icon-availability</v-icon>
                        submit
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card v-if="editeditem.group_id !== ''" flat>
                  <!-- <v-card-title>
                 <span class="text-h5">Edit widget configuration</span> 
              </v-card-title> -->
                  <div
                    style="display: flex; justify-content: space-evenly; flex-wrap: wrap"
                    class="ml-5 mr-5"
                  >
                    <!-- <v-container> -->
                    <v-row>
                      <v-col
                        cols="4"
                        style="padding: 0 12px;"
                        v-for="(i, index) in newConfigureParamData"
                        :key="index"
                      >
                        <div
                          @mouseover="showInfoMessageForNewDash(index)"
                          @mouseout="hideInfoMessageForNewDash(index)"
                        >
                          <span style="position: relative; z-index: -1;">{{
                            count2
                          }}</span>
                          <div v-if="i['data_type'] === 'integer'">
                            <v-text-field
                              :messages="
                                i['showMessageBoolean'] ? i['info'] : ''
                              "
                              :label="i['display_name']"
                              v-model.number="i['param_value']"
                              type="number"
                            >
                            </v-text-field>
                          </div>
                          <div v-if="i['data_type'] == 'string'">
                            <v-text-field
                              :messages="
                                i['showMessageBoolean'] ? i['info'] : ''
                              "
                              :label="i['display_name']"
                              v-model="i['param_value']"
                              type="text"
                            >
                            </v-text-field>
                          </div>

                          <div v-if="i['data_type'] == 'boolean'">
                            <v-autocomplete
                              :messages="
                                i['showMessageBoolean'] ? i['info'] : ''
                              "
                              v-model="i['param_value']"
                              :items="boolean_val_param"
                              :label="i['display_name']"
                            ></v-autocomplete>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <!-- </v-container> -->

                    <!-- </v-container> -->
                  </div>
                </v-card>
                <v-card-actions class="pb-5">
                  <v-spacer></v-spacer>
                  <v-btn rounded color="#FE000C" @click="close">
                    <v-icon left class="icon-white">icon-cancel</v-icon>
                    <span style="color:white">Cancel</span>
                  </v-btn>
                  <v-btn rounded color="primary" @click="save">
                    <v-icon left>icon-availability</v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-tab-item>
            </v-tabs>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- This will open configuration dashboard which is shown by pencil icon -->
      <template v-slot:item.configure_edit="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="OpenConfigEdit(item)"
          id="configPencilIcon"
        >
          icon-action
        </v-icon>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          icon-action
        </v-icon>
      </template>
      <template v-slot:item.enable_status="{ item }">
        <v-switch
          color="indigo"
          @change="changeStatus(item, item.enable_status)"
          false-value="N"
          true-value="Y"
          v-model="item.enable_status"
        ></v-switch>
      </template>
      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="setGridData"> Reset </v-btn>
      </template> -->
    </v-data-table>
    <div id="sucessAlert">
      <v-alert outlined type="success" text> Data Saved successfully. </v-alert>
    </div>
    <div id="errorAlert">
      <v-alert outlined type="warning" prominent border="left">
        Error while saving the data.
      </v-alert>
    </div>
  </v-container>
</template>
<script>
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";

import axios from "axios";
// import constants from "../constants";
import VueJsonToCsv from "vue-json-to-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import router from "../router";
// const logo = require("../assets/trinitiimage.png");

export default {
  components: {
    VueJsonToCsv,
    Breadcrumb,
    LoaderProgress,
  },
  data: () => ({
    count2: 0,
    count: 0,
    EditParamView: false,

    newConfigEditDialogue: false,
    newConfigureParamData: "",
    boolean_val_param: ["true", "false"],
    showLoader: false,
    messagShow: false,

    headersData: [],

    // configOpenNewDash:false,

    form: {
      parent_id: [],
    },
    operatorsData: [],
    dialogConfigWidget: false,
    typeOfInput: "number",
    // dialogwidgetShow:false,
    pagination: {
      page: null,
      itemsPerPage: null,
      pageStart: null,
      pageStop: null,
      pageCount: null,
      itemsLength: null,
    },
    isEdit: false,
    dataDownload: [],
    parameters: [],
    machineItems: [],
    groupItems: [],
    selectProps: {
      phones: [],
    },

    menu: false,
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Admin Menu",
        disabled: true,
        href: "/",
      },
      {
        text: "Dash Board Management",
        disabled: true,
      },
    ],
    selected_group_id: null,
    selected_machine_id: null,
    selected_parameter_id: null,
    allParametersKeyValue: null,
    param_display_value: [],
    param_key_value_dict: null,
    param_display_name: [],

    mydata: [],
    search: "",
    dialog: false,
    lengthOfAllParameter: null,
    editedIndex: -1,
    editeditem: {
      id: null,
      machine_id: "",
      parameter_name: "",
      parameter_id: "",
      machine_name: "",
      group_id: "",
      group_name: "",
      enable_status: "Y",
      alias_name: null,
    },
    editeditem_config: {
      graph: "sumit",
    },
    defaultItem: {
      machine_id: "",
      machine_name: "",
      parameter_id: "",
      parameter_name: "",
      group_id: "",
      group_name: "",
      enable_status: "Y",
      alias_name: null,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Add Dash Board Config"
        : "Edit Dash Board Config";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    // console.log("Method inside created")
    this.setGridData();
    this.setMachineData();
    this.setGroupData();
    // this.setparametersData();
  },
  mounted() {},
  methods: {
    showInfoMessageForNewDash(index) {
      try {
        this.newConfigureParamData[index]["showMessageBoolean"] = true;
        console.log("error");
        this.count2 = this.count2 + 1;
      } catch (error) {
        window.alert("error", error);
      }
    },
    hideInfoMessageForNewDash(index) {
      try {
        this.newConfigureParamData[index]["showMessageBoolean"] = false;
        this.count2 = this.count2 + 1;
      } catch (error) {
        window.alert("error", error);
      }
    },
    showInfoMessage(index) {
      this.$set(this.allParametersKeyValue[index], "showMessageBoolean", true);
      this.count = this.count + 1;
    },
    hideInfoMessage(index) {
      this.$set(this.allParametersKeyValue[index], "showMessageBoolean", false);
      this.count = this.count + 1;
    },

    changeActivestatus(item) {
      this.editeditem.enable_status = item;
    },
    onlyNumber: function($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    createPDF() {
      let content = this.$refs["theDataTable"];
      console.log("pagination", this.pagination);
      let doc = new jsPDF();
      doc.text(14, 7.5, "Dash Board Configuration");
      doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimenstion,
        this.$config.second_dimenstion,
        this.$config.third_dimension,
        this.$config.fourth_dimension
      );
      let columnHeaders = ["Machine", "Parameter", "Group", "Status"];
      let rows = [];
      content.items.forEach((data, index) => {
        if (
          index >= this.pagination.pageStart &&
          index < this.pagination.pageStop
        ) {
          let tempRow = [
            data.machine_name || "",
            data.parameter_name || "",
            data.alias_name || "",
            data.group_name || "",
            data.enable_status === "Y" ? "On" : "Off",
          ];
          rows.push(tempRow);
        }
      });
      doc.setFontSize(9);
      doc.autoTable(columnHeaders, rows, { startY: 11.5 });
      let d = new Date();
      doc.save(
        `Dash_Board_Configuration_Management ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`
      );
    },
    changeStatus(item, enable_status) {
      console.log("checking item and status", item, enable_status);
      let updated_user = sessionStorage.getItem("activeUser") || "";
      console.log("checking updated user", updated_user);

      const req = {
        id: item.id,
        // machine_id: item.machine_id,
        // parameter_name: item.parameter_name,
        // updated_by: updated_user,
        //    group_name: item.group_name,
        // machine_id: item.machine_id,
        active: enable_status,
      };
      // console.log("modifying machines", req, enable_status);
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateDashBoardConfiguration`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: req,
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
    },
    //this method will save the new configure dashborad parameter that can be inserted while creating new dashboarad
    newConfigdataInsertionparam(
      machine_id,
      group_id,
      parameter_id,
      alias_name
    ) {
      console.log("method executuinn", this.newConfigureParamData);
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/newDashBoardConfigureParameterSave`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          data: this.newConfigureParamData,
          machine_id: machine_id,
          group_id: group_id,
          parameter_id: parameter_id,
          alias_name: alias_name,
        },
      };
      axios(config).then((response) => {
        this.showLoader = false;
        if (response.data.status == "S") {
          document.querySelector("#sucessAlert").style.display = "block";
          // this.setGridData();
        }
      });
      this.showLoader = false;
      this.newConfigureParamData = "";
    },

    closeConfigWidget() {
      this.dialogConfigWidget = false;
      // this.newConfigEditDialogue=false;
      console.log("this.allParametersKeyValue", this.newConfigEditDialogue);
    },
    saveconfigWidget() {
      this.dialogConfigWidget = false;
      // this.newConfigEditDialogue=false;
      console.log("this.mydata", this.allParametersKeyValue);
      // console.log("new config param data",this.newConfigureParamData)
      this.showLoader = true;
      let config = {
        method: "post",
        url: `${this.$config.backend_url}/updateConfigurationWidgetparameter`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          parameter: this.allParametersKeyValue,
          group_id: this.selected_group_id,
          machine_id: this.selected_machine_id,
          parameter_id: this.selected_parameter_id,
        },
      };
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            document.querySelector("#sucessAlert").style.display = "block";
            this.setGridData();
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
      this.showLoader = false;
    },
    setGridData: function() {
      this.headersData = [
        {
          text: "Machine",
          value: "machine_name",
          sortable: true,
        },
        {
          text: "Parameter",
          value: "parameter_name",
          sortable: true,
        },
        {
          text: "Dashboard Name",
          value: "alias_name",
          sortable: true,
        },
        {
          text: "Group",
          value: "group_name",
          sortable: true,
        },
        {
          text: "Status",
          value: "enable_status",
          sortable: true,
        },
        { text: "configure widget", value: "configure_edit", sortable: false },

        { text: "Actions", value: "actions", sortable: true },
      ];
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getDashBoardConfiguration`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("checking machines=>", response.data.data);
          let _data = response.data.data;
          this.operatorsData = response.data.data;
          let result = [];
          for (let i in response.data) result.push([i, response.data[i]]);
          console.log("checking result data=>", result[0][1]);
          this.dataDownload = result[0][1];
          this.item = _data;
          console.log("response.data.data", this.item);
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },

    setMachineData() {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getMachineNames`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--getMachineNames", response.data);
          let machineData = response.data.data;
          // machineData.sort((first_machine, second_machine) => {
          //   return this.compareObjects(
          //     first_machine,
          //     second_machine,
          //     "machine_name"
          //   );
          // });
          // console.log("cehcking machine dayta=>", machineData);
          let replaceKeyData = this.replaceKey(machineData);
          console.log("replace key=>", replaceKeyData);
          this.machineItems = machineData;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            console.log("axios error", error.message);
          }
        });
    },
    setGroupData(mac_id = null) {
      this.showLoader = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getGroupNames?machine_id=${mac_id}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      if (mac_id == null) {
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getGroupNames`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
      }
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          console.log("response--getMachineNames", response.data);
          let groupData = response.data.data;
          // groupData.sort((first_machine, second_machine) => {
          //   return this.compareObjects(
          //     first_machine,
          //     second_machine,
          //     "group_name"
          //   );
          // });
          console.log("cehcking group dayta=>", groupData);
          let replaceKeyData = this.replaceKey(groupData);
          console.log("replace key=>", replaceKeyData);
          this.groupItems = groupData;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            console.log("axios error", error.message);
          }
        });
    },
    setparametersData(mac_id = null) {
      console.log("checking machine_id", this.editeditem.machine_id);

      this.showLoader = true;
      //   console.log("this.machineItems=>",this.machineItems);
      // Object.keys(this.machineItems).forEach((key) => {
      // key.forEach((machi)=>{
      //     console.log(machi.id,machi.machine_name);
      // });});
      for (let i = 0; i < this.machineItems.length; i++) {
        // console.log("checking items",this.machineItems[i],this.editeditem.machine_name);
        if (this.machineItems[i].machine_name == this.editeditem.machine_name) {
          mac_id = this.machineItems[i].id;
        }
      }
      //   console.log("checking edited item",this.editeditem, mac_id);

      //   let machine_id =
      let config = null;
      if (mac_id != null) {
        //   console.log("checking edited item inside",this.editeditem);
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getParametersData?machine_id=${mac_id}`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
      } else {
        config = {
          method: "get",
          url: `${this.$config.backend_url}/getParametersData?`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
      }
      this.setGroupData(mac_id);
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          //   console.log("response--getParametersData", response.data);
          let deviceType = response.data.data;
          // deviceType.sort((first_machine, second_machine) => {
          //   return this.compareObjects(
          //     first_machine,
          //     second_machine,
          //     "parameter_name"
          //   );
          // });
          //   console.log("cehcking machine dayta=>", deviceType);
          let replaceKeyData = this.replaceKey(deviceType);
          console.log("replace key=>", replaceKeyData);
          this.parameters = deviceType;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    // this method will save param for created dashboard
    getparameterForNewdashBoradCreated(group_id) {
      console.log("method started", group_id);
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getNewDashBoradConfigParametrs?group_id=${group_id}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            this.newConfigEditDialogue = true;

            console.log(
              "getparameterForNewdashBoradCreated started",
              this.newConfigEditDialogue,
              response.data.data
            );
            this.newConfigureParamData = response.data.data;

            for (let i = 0; i < this.newConfigureParamData.length; i++) {
              console.log(i);
              this.newConfigureParamData[i]["showMessageBoolean"] = false;
            }
            console.log(
              "newConfigureParamDatanewConfigureParamData",
              this.newConfigureParamData
            );
            this.EditParamView = true;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    addDoc() {
      this.isEdit = false;

      this.configOpenNewDash = true;
      this.EditParamView = false; //closing the tab
    },
    replaceKey(oldObject) {
      let newWordsObject = {};
      Object.keys(oldObject).forEach((key) => {
        if (key === "machine_id") {
          let newPair = { ["machine_id"]: oldObject[key] };
          newWordsObject = { ...newWordsObject, ...newPair };
        } else {
          newWordsObject = { ...newWordsObject, [key]: oldObject[key] };
        }
      });
    },

    //this will  open config and make apin call to backend with selected param to configure the parameter
    OpenConfigEdit(item) {
      console.log("sumit panchbhai", item);
      this.dialogConfigWidget = true;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/configureWidget?group_id=${item.group_id}&machine_id=${item.machine_id}&parameter_id=${item.parameter_id}&widget_id=${item.widget_id}&id=${item.id}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      console.log(config);
      this.selected_group_id = item.group_id;
      this.selected_machine_id = item.machine_id;
      this.selected_parameter_id = item.parameter_id;
      axios(config)
        .then((response) => {
          this.showLoader = false;
          if (response.data.status == "S") {
            console.log("response.data", response.data.data);
            this.allParametersKeyValue = response.data.data;
            for (let i = 0; i < this.allParametersKeyValue.length; i++) {
              console.log(i);
              this.allParametersKeyValue[i]["showMessageBoolean"] = false;
            }
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            document.querySelector("#errorAlert").style.display = "block";
            console.log("axios error", error.message);
          }
        });
    },
    //chnage
    editItem(item) {
      this.setparametersData(item.machine_id);
      this.setGroupData(item.machine_id);
      this.isEdit = true;

      this.editedIndex = this.operatorsData.indexOf(item);
      this.editeditem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.EditParamView = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editeditem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      // window.alert("click save button")
      // console.log("req is sumit", req);
      // this.EditParamView=false

      if (
        this.editeditem.parameter_id === null ||
        this.editeditem.parameter_id === ""
      ) {
        alert("Please Enter parameter ");
        return;
      } else if (
        this.editeditem.enable_status === null ||
        this.editeditem.enable_status === ""
      ) {
        alert("Please enable or disable ");
        return;
      } else if (
        this.editeditem.machine_name === null ||
        this.editeditem.machine_name === ""
      ) {
        alert("Please Enter machine name ");
        return;
      } else if (
        this.editeditem.group_id === null ||
        this.editeditem.group_id === ""
      ) {
        alert("Please Enter group name ");
        return;
      }

      let processFurther = true;
      for (let i of this.newConfigureParamData) {
        if (i["restriction"] === true && i["param_value"] === null) {
          window.alert(`please fill the ${i["display_name"]}`);
          processFurther = false;
        }
      }
      if (processFurther === true) {
        for (let i in this.parameters) {
          if (this.parameters[i].parameter_id == this.editeditem.parameter_id) {
            this.editeditem.parameter_name = this.parameters[i].parameter_name;
          }
        }
        for (let i in this.machineItems) {
          // console.log("checkign inside for", this.machineItems[i]);
          if (this.machineItems[i].machine_name == this.editeditem.machine_name)
            this.editeditem.machine_id = this.machineItems[i].id;
        }
        let updated_user = sessionStorage.getItem("activeUser") || "";
        let user = sessionStorage.getItem("activeUser", this.editeditem) || "";
        // console.log("checking parameterskkc=>", this.editeditem);
        const req = {
          id: this.isEdit ? this.editeditem.id : undefined,
          created_by: this.isEdit ? undefined : user,
          updated_by: this.isEdit ? updated_user : undefined,
          parameter_name: this.editeditem.parameter_name,
          parameter_id: this.editeditem.parameter_id,
          machine_id: this.editeditem.machine_id,
          machine_name: this.editeditem.machine_name,
          alias_name: this.editeditem.alias_name,
          group_name: this.editeditem.group_name,
          group_id: this.editeditem.group_id,
          active: this.editeditem.enable_status,
        };

        // console.log("checking req", this.editeditem);
        var newConfigData = this.editeditem;
        let url = this.isEdit
          ? `${this.$config.backend_url}/updateDashBoardConfiguration`
          : `${this.$config.backend_url}/DashBoardConfigurationDataEntry`;
        // console.log("req is sumit 1111", req);
        this.showLoader = true;
        let config = {
          method: "post",
          url: url,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: req,
        };
        console.log("configconfigconfig", config);
        this.noteLastAPICallTime();
        axios(config)
          .then((response) => {
            this.showLoader = false;
            if (response.data.status == "S") {
              this.EditParamView = false; //closing the tab
              document.querySelector("#sucessAlert").style.display = "block";
              console.log("checking data this.editeditem", newConfigData);
              this.newConfigdataInsertionparam(
                newConfigData.machine_id,
                newConfigData.group_id,
                newConfigData.parameter_id,
                newConfigData.alias_name
              );
              this.setGridData();
            }
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              document.querySelector("#errorAlert").style.display = "block";
              console.log("axios error", error.message);
            }
          });

        console.log(
          "checkign values ==>123",
          typeof this.newConfigureParamData
        );

        //calling method to store the data while creating new dashboard
        // this.newConfigdataInsertionparam(this.editeditem.machine_id,this.editeditem.group_id,this.editeditem.parameter_id,this.editeditem.alias_name)
        this.close();
      }

      // console.log("checking edit=>", this.editeditem);
      // console.log("checking machines", this.machineItems);
    },
  },
};
</script>
<style scoped>
.v-tabs-slider {
  height: 200% !important;
  width: 100% !important  ;
  color: #fe000c !important;
}

.theme--light.v-tabs > .v-tabs-bar {
  background-color: #0c479d !important;
}
.position-static {
  position: static;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#sucessAlert {
  display: none;
}
#errorAlert {
  display: none;
}
#configPencilIcon {
  margin: 0px 25px;
}

.main-content {
  flex: 1;
  margin: 2%;
  padding: 2%;
  background-color: white;
  box-shadow: 0px 0px 5px black;
  overflow-y: scroll;
}

.container {
  display: flex;
  flex-direction: column;
  background: #fafafa;
  height: 100%;
}

.header {
  background-color: #3f51b5;
  padding: 1%;
  color: white;
}

/* .ParameterConfigCard {
  width: 600px; 
  height: 350px; 
  overflow-y: auto; 
  } */
</style>
